import {
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_LOGS,
  GET_USER_LOGS_SUCCESS,
  GET_USERS,
  GET_USERS_SUCCESS,
  DELETE_USER,
  DELETE_USER_CLIENT_SUCCESS,
  DELETE_USER_ROLE_SUCCESS,
  SET_USER_CLIENT_SUCCESS,
  SET_USER_ROLE_SUCCESS,
  CHANGE_USER_ROLE_SUCCESS,
  SELECT_USER,
  USERS_ERROR,
  SYNC_INIT_START,
  SYNC_INIT_STOP,
  SYNC_META_START,
  SYNC_META_STOP,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCESS,
  GET_PAGINATED_USER_LOGS,
  GET_PAGINATED_USER_LOGS_SUCCESS,
  REFRESH_USER_INFO,
  USER_EMAIL_CHANGE,
  CREATE_USER,
} from '../constants/action-types/users';

import { UPDATE_USER_LIST } from '../constants/action-types/clients';

import { initialStateUsers } from '../store/models/users';

export default function usersReducer(state = initialStateUsers, action) {
  switch (action.type) {
    case CREATE_USER:
      return { ...state, submittingUser: true };
    case SELECT_USER:
      return { ...state, id: action.id };
    case REFRESH_USER_INFO:
      return {
        ...state,
        createUserError: (action.data || {}).error,
        submittingUser: false,
      };
    case USER_EMAIL_CHANGE:
      return {
        ...state,
        createUserError: {},
      };
    case GET_USER:
      return {
        ...state,
        selectedUser: {},
        isLoading: true,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        selectedUser: action.data,
        isLoading: false,
      };
    case GET_USER_LOGS:
      return {
        ...state,
        selectedUserLogs: [],
        loadingUserLogs: true,
      };
    case GET_USER_LOGS_SUCCESS:
      return {
        ...state,
        selectedUserLogs: action.data,
        loadingUserLogs: false,
      };
    case GET_PAGINATED_USER_LOGS:
      return {
        ...state,
        selectedPaginatedUserLogs: {},
        loadingUserLogs: true,
      };
    case GET_PAGINATED_USER_LOGS_SUCCESS:
      return {
        ...state,
        selectedPaginatedUserLogs: action.data,
        loadingUserLogs: false,
      };
    case GET_USERS:
      return {
        ...state,
        users: [],
        isLoading: true,
        isEditing: false,
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.data,
        isLoading: false,
      };
    case DELETE_USER:
      return {
        ...state,
        isEditing: false,
        isLoading: true,
        selectedUser: {},
        users: state.users.filter(user => user.id !== action.id),
      };
    case DELETE_USER_CLIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isEditing: false,
      };
    case DELETE_USER_ROLE_SUCCESS:
      return {
        ...state,
        isEditing: false,
        selectedUser: action.data,
        users: state.users.map(user => (user.id === action.data.id ? action.data : user)),
      };
    case SET_USER_CLIENT_SUCCESS:
      return {
        ...state,
        isEditing: false,
      };
    case SET_USER_ROLE_SUCCESS:
      return {
        ...state,
        isEditing: false,
        selectedUser: action.data,
      };
    case UPDATE_USER_LIST:
      return {
        ...state,
        users: action.users,
        isLoading: false,
      };
    case CHANGE_USER_ROLE_SUCCESS:
      return {
        ...state,
      };
    case USERS_ERROR:
      return {
        ...state,
        isLoading: false,
        isEditing: false,
      };
    case SYNC_INIT_START:
      return {
        ...state,
        initSyncInProgress: true,
      };
    case SYNC_INIT_STOP:
      return {
        ...state,
        initSyncInProgress: false,
      };
    case SYNC_META_START:
      return {
        ...state,
        metaSyncInProgress: true,
      };
    case SYNC_META_STOP:
      return {
        ...state,
        metaSyncInProgress: false,
      };
    case CHANGE_USER_PASSWORD:
      return {
        ...state,
        isLoading: true,
      };
    case CHANGE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
